import { NEW_FLOW_BANNER_HEADING, NEW_FLOW_BANNER_SUBHEADING, NEW_FLOW_CTA_TEXTS, NEW_FLOW_ICON_ALT, NEW_FLOW_ICON_POSITION, NEW_FLOW_ICON_SRC, BIKE_WIDGET_INPUT_PLACEHOLDER } from './constant'

export const getPurpleVariantProps = (selectedProduct, defaultValuesProps, widgetOptions) => {
  const bikeWidgetProps = widgetOptions?.bikeNewFlowBannerWidgetOptions

    if (selectedProduct === 'bike') {
      return {
        widgetHeading: defaultValuesProps?.widgetHeading,
        disclaimer: defaultValuesProps?.disclaimer,
        inputPlaceholder: BIKE_WIDGET_INPUT_PLACEHOLDER,
        newFlowBanner: {
            id: 1,
            heading: bikeWidgetProps?.heading || NEW_FLOW_BANNER_HEADING,
            subHeading: bikeWidgetProps?.subHeading || NEW_FLOW_BANNER_SUBHEADING,
            ctaText: bikeWidgetProps?.ctaText || NEW_FLOW_CTA_TEXTS,
            iconSrc: bikeWidgetProps?.iconSrc || NEW_FLOW_ICON_SRC,
            iconAlt: bikeWidgetProps?.iconAlt || NEW_FLOW_ICON_ALT,
            iconPosition: bikeWidgetProps?.iconPosition || NEW_FLOW_ICON_POSITION
        },
        isSemPage: defaultValuesProps?.isSemPage,
        isOldLayout: defaultValuesProps?.isOldLayout,
        segmentEventCommonProperties: defaultValuesProps?.segmentEventCommonProperties,
        widgetCtaText: defaultValuesProps?.widgetCtaText,
        widgetVariant: defaultValuesProps?.widgetVariant,
        combinedStyles: defaultValuesProps?.combinedStyles,
        regexPatternsData: defaultValuesProps?.regexPatternsData,
        isBottomFloater: defaultValuesProps?.isBottomFloater,
      }
    }

    return {
      ...defaultValuesProps
    }
  }
